import styled from 'styled-components'

import { focusVisibleOutline } from '@subaio/components'

import { theme } from '../../../styles/theme'

type Props = {
	isChecked: boolean
	isDisabled: boolean
	isFocusVisible: boolean
	isHovered: boolean
	isReadOnly: boolean
	isInvalid: boolean
}

export const CheckMark = styled.div<Props>`
	position: relative;
	cursor: ${({ isDisabled, isReadOnly }) => (!isDisabled && !isReadOnly ? 'pointer' : 'auto')};
	border: 1px ${({ isReadOnly }) => (isReadOnly ? 'dashed' : 'solid')} ${({
		isDisabled,
		isChecked,
		isHovered,
		isReadOnly,
		isInvalid,
	}) => {
		if (isInvalid) {
			return theme.color.input.borderError
		}
		if (isDisabled || isReadOnly) {
			if (isChecked) return theme.color.input.contentDisabled
			return theme.color.input.border
		}
		if (isChecked) {
			if (isHovered) return theme.color.input.toggleBackgroundCheckedHover
			return theme.color.input.toggleBackgroundChecked
		}
		if (isHovered) return theme.color.input.borderHover
		return theme.color.input.border
	}};
	border-radius: 4px;
	width: 22px;
	height: 22px;
	flex-shrink: 0;
	background-color: ${({ isChecked, isDisabled, isHovered, isReadOnly, isInvalid }) => {
		if (isInvalid) {
			return theme.color.input.backgroundErrorHover
		}
		if (isDisabled || isReadOnly) {
			if (isChecked) return theme.color.input.contentDisabled
			return theme.color.input.backgroundDisabled
		}
		if (isChecked) {
			if (isHovered) return theme.color.input.toggleBackgroundCheckedHover
			return theme.color.input.toggleBackgroundChecked
		}
		if (isHovered) return theme.color.input.backgroundHover
		return theme.color.input.background
	}};
	transition: background-color 150ms ease-in-out, border-color 150ms ease-in-out;

	${focusVisibleOutline(theme.color.input.focusOutline)};
`
